import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { ALERT_TYPES } from 'constants/alert-constants'
import TitlePage from 'components/atoms/title-page'
import CustomerVoucherRulesApiV2 from 'api/v2/admins/customer-voucher-rules-api-v2'
import PropTypes from 'prop-types'
import { VoucherForm } from 'domains/voucher/organisms'
import { Spinner } from 'reactstrap'

const propTypes    = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}
const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const VoucherEditPage = ({ pageUtils }) => {

  const { id } = useParams()

  const [ isLoading, setIsLoading ] = useState(true)
  const [ voucher, setVoucher ]     = useState({})

  useEffect(() => {
    CustomerVoucherRulesApiV2.getSingle(id)
      .then((response) => {
        setVoucher(response.data.rule)
        setIsLoading(false)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ id, pageUtils ])

  const handleSubmitForm = async (values) => {

    await CustomerVoucherRulesApiV2.update(id, values)
      .then((response) => {
        setVoucher(response.data.rule)
        pageUtils.setAlertMsg('Voucher updated!', ALERT_TYPES.SUCCESS)
        window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' })
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }

  return (
    <>
      <TitlePage
        mainTitle='Edit Voucher'
        subTitle={ voucher?.name }
      />
      {
        isLoading
          ? <Spinner color='primary'/>
          : (
            <VoucherForm
              voucherRule={ voucher }
              onSubmit={ handleSubmitForm }
            />
          )
      }

    </>
  )
}

VoucherEditPage.propTypes    = propTypes
VoucherEditPage.defaultProps = defaultProps

export default VoucherEditPage
